/*
 * @Author: luting
 * @Date: 2022-04-09 13:54:15
 * @lastEditors: luting
 * @LastEditTime: 2023-06-07 16:51:04
 */
import React, { useState, useEffect } from 'react';
import { message, Spin } from 'sup-ui';
import { useIntl } from 'react-intl';
import messages from './messages';
import { SelectDiskListDataType, diskConfigType, PartitionType } from './diskTypes';
import {
  getAvailabledDisksApi,
  getDiskConfigApi,
  postPartitionApi,
  postVgdeleteApi,
  getPartitionStatusApi,
  postDiskResizeApi,
  getVginfo,
} from '../../services/disk';

import { useDispatch, useSelector } from 'react-redux';
import { reducerStates } from 'root/store/types';
import { disk } from 'root/store/disk/actions';
import { judgeTotalSize } from 'root/utils/getUnallocatedBlock';

import SelectDisk from './SelectDisk';
import ConfirmDiskBody from './ConfirmDiskBody';
import ConfirmDiskHead from './ConfirmDiskHead';
import ConfirmDiskFooter from './ConfirmDiskFooter';
import ChangeDisk from './ChangeDisk';
import Modal from 'root/components/CommonModal';

import styles from './index.less';

const DiskConfig = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [currentProgress, setCurrentProgress] = useState('selectDisk'); // 控制当前流程的进度 可以确认head与footer的btn
  const { confirmDiskData, record } = useSelector((state: reducerStates) => state.disk); // confirmDiskData 当前配置的卷组数据,record为扩展分区时modal中的当前那一条数据
  const { serverStatus } = useSelector((state: reducerStates) => state.common);
  const { singleNodeId, cluster } = useSelector((state: reducerStates) => state.envManage);
  const [slesctDiskListData, setSlesctDiskListData] = useState<SelectDiskListDataType[]>([]); // 选择磁盘中的数据
  const [vginfo, setVginfo] = useState<any[]>([]); // 可选择的卷组信息
  const [selectDiskKeys, setSelectDiskKeys] = useState<string[]>([]); // 被选中的磁盘的lvpath
  const [partitionType, setPartitionType] = useState(1); // 创建分区类型（1：新的磁盘创建， 2：已有卷组）

  const [vginfoSize, setVginfoSize] = useState(0); // 被选中的卷组的数量
  const [vgName, setVgname] = useState(''); // 被选中的卷组名称

  const [updateDiskConfig, setUpdateDiskConfig] = useState(false); // 控制全新状态时容量是否为编辑状态
  const [loading, setLoading] = useState(false);
  const [tip, setTip] = useState(''); // 格式化提示
  const [err, setErr] = useState(''); // 分区状态失败后错误提示
  const [showMinLimtTip, setShowMinLimtTip] = useState(false);
  const [minLimt, setMinLimt] = useState(false);
  let loopTimer: any = null;

  useEffect(() => {
    // 格式化失败后重进入选择磁盘界面
    if (singleNodeId && currentProgress === 'selectDisk') {
      setLoading(true);
      getAvailabledDiskEvent();
      getVginfoEvent();
    }
  }, [currentProgress]);

  // 获取磁盘数据
  const getAvailabledDiskEvent = () => {
    getAvailabledDisksApi({ clientIds: [singleNodeId as string] }).then((res) => {
      const { data = [] } = res;
      setSlesctDiskListData(data);
      setLoading(false);
    });
  };

  // 获取卷组信息
  const getVginfoEvent = () => {
    getVginfo({ clientIds: [singleNodeId as string] }).then((res) => {
      const { data = [] } = res;
      setVginfo(data);
      setLoading(false);
    });
  };

  // 选择磁盘结束，点击下一步
  const clickStartConfirmDisk = () => {
    setShowMinLimtTip(false);
    // 没选择磁盘或者没有选择已有卷组不允许点击下一步
    if (!selectDiskKeys.length && partitionType === 1) {
      message.warn(intl.formatMessage(messages.selectDisk));
      return;
    }

    // 没选择磁盘或者没有选择已有卷组不允许点击下一步
    if (!vginfoSize && partitionType === 2) {
      message.warn(intl.formatMessage(messages.selectVginfo));
      return;
    }

    //  判断选择的卷组无可用空间，提示异常信息 partitionType:2 选的是已有卷组
    if (vginfoSize <= 0 && partitionType === 2) {
      message.warn(intl.formatMessage(messages.usableSizeTip));
      return;
    }

    // size为选择磁盘的容量合计
    const size = slesctDiskListData.reduce((pre, cur) => {
      return selectDiskKeys.includes(cur.path) ? pre + Number(cur.size) : pre;
    }, 0);

    // 如果选择的磁盘总量不到400 显示提示 ( 4.2.1 不限制最小值)
    // if (size < 400 && vginfoSize < 400) {
    //   setShowMinLimtTip(true);
    //   return;
    // }

    getAvailableConfirmDiskData(partitionType === 1 ? size : vginfoSize).then(() => {
      // 流程进入确认配置
      setCurrentProgress('confirmDisk');
    });
  };

  // 获取磁盘配置
  const getAvailableConfirmDiskData = (size: number) => {
    return getDiskConfigApi({
      size,
      clientIds: [singleNodeId as string],
      cluster: Number(cluster),
      vgName: partitionType === 2 ? vgName : '',
    }).then((res) => {
      const { data: { diskConfigs = [] } = {} } = res;
      saveDiskData(diskConfigs);
    });
  };

  // 存到store中
  const saveDiskData = (data: diskConfigType[]) => {
    dispatch(
      disk.getDiskData({
        confirmDiskData: data,
      }),
    );
  };

  // 点击刷新
  const clickRefershEvent = () => {
    setSelectDiskKeys([]);
    setLoading(true);
    //  根据交互要求将loading时间延长
    setTimeout(() => {
      getAvailabledDiskEvent();
      getVginfoEvent();
    }, 2000);
  };

  // 点击上一步
  const clickLastStepEvent = () => {
    setCurrentProgress('selectDisk');
    setUpdateDiskConfig(false);
  };

  // 点击开始分区弹出二次弹窗
  const clickPartitionEvent = () => {
    if (judgeTotalSize(confirmDiskData[0]).result) {
      message.error(intl.formatMessage(messages.judgeTotalSize));
      return;
    }
    setUpdateDiskConfig(false);
    Modal.confirm({
      onOk: startBlockEvent,
      okText: intl.formatMessage(messages.beginToPartition),
      cancelText: intl.formatMessage(messages.consider),
      content: intl.formatMessage(messages.groupTip),
    });
  };

  // 点击二次弹窗确认开始分区
  const startBlockEvent = () => {
    const { mountPoints, vgName, totalSize } = confirmDiskData[0];
    const params: PartitionType = {
      standard: true,
      vgName: vgName,
      id: 1,
      extraMPs: [],
      diskList: selectDiskKeys,
      mountPoints: mountPoints.map((item: any) => ({ name: item.mountPoint, size: item.size })),
      totalSize: totalSize.toString(), // 后端接string类型
      clientIds: [singleNodeId as string],
    };

    postPartitionApi(params).then(() => {
      setCurrentProgress('partitionDisk');
      getPartionInfo();
    });
  };

  // 轮询获取分区状态
  const loopGetData = () => {
    loopTimer = setTimeout(() => {
      clearTimeout(loopTimer);
      getPartionInfo();
    }, 3000);
  };

  // 获取分区信息
  const getPartionInfo = () => {
    getPartitionStatusApi({ clientIds: [singleNodeId as string] }).then((res) => {
      // 分区完成
      if (res.data.status === 'FINISHED') {
        clearTimeout(loopTimer);
        loopTimer = null;
        if (res.data.result === 'SUCCESS') {
          setCurrentProgress('confirmInstall');
          getAvailableConfirmDiskData(0);
        } else {
          setCurrentProgress('partitionFailed');
        }
        setErr(res.data.err);
        return;
      }
      // 正在分区中
      loopGetData();
    });
  };

  // 格式化分区
  const deletePartition = async () => {
    setLoading(true);
    setTip('正在格式化...');
    const body = {
      vgPath: confirmDiskData[0]?.vgPath,
      delete: true,
      clientIds: [singleNodeId as string],
    };
    // 格式化分区成功后重新加载页面开始前几步操作
    postVgdeleteApi(body)
      .then(() => {
        setCurrentProgress('selectDisk');
        setSelectDiskKeys([]);
      })
      .finally(() => {
        setLoading(false);
        setTip('');
      });
  };

  // 格式化重新安装
  const formatBlock = () => {
    const id = confirmDiskData[0].id;
    // 保存id,通过id去筛选出当前的record数据,将changeDisk组件的modal设置为true
    dispatch(
      disk.getDiskId({
        id,
      }),
    );
    dispatch(
      disk.filterRecord({
        id,
      }),
    );
    dispatch(disk.getVisible({ visible: true }));
  };

  // 扩展分区
  const updateSize = () => {
    if (judgeTotalSize(record as diskConfigType).result) {
      message.error(intl.formatMessage(messages.judgeTotalSize));
      return Promise.reject(new Error('2'));
    }

    const params: any = record?.mountPoints.map((ele: any) => ({
      lvPath: ele.lvPath,
      size: Number(ele.size),
    }));

    return postDiskResizeApi({
      resizeList: params,
      clientIds: [singleNodeId as string],
    }).then(() => {
      message.success(intl.formatMessage(messages.partitionSuccess));
      getAvailableConfirmDiskData(0);
    });
  };

  return (
    <div className={styles.container}>
      {currentProgress && (
        <div className={styles.diskContent}>
          <ConfirmDiskHead currentProgress={currentProgress} err={err} />

          <div className={styles.serviceSetContainer}>
            <Spin spinning={loading} size="large" tip={tip}>
              <div className={styles.serviceSetContent}>
                {currentProgress === 'selectDisk' ? (
                  <SelectDisk
                    diskListData={slesctDiskListData}
                    selectDiskKeys={selectDiskKeys}
                    setSelectDiskKeys={setSelectDiskKeys}
                    vginfoData={vginfo}
                    setVginfoSize={setVginfoSize}
                    setPartitionType={setPartitionType}
                    partitionType={partitionType}
                    setVgname={setVgname}
                    vgName={vgName}
                  />
                ) : (
                  confirmDiskData.map((item: diskConfigType) => (
                    <ConfirmDiskBody
                      key={item.id}
                      id={item.id}
                      freeSize={item.freeSize}
                      totalSize={item.totalSize}
                      vgPath={item.vgPath}
                      vgName={item.vgName}
                      dataSource={item.mountPoints}
                      columnLists={['mountPoint', 'size']}
                      updataDiskSize={updateDiskConfig}
                      lessen={true}
                      setMinLimt={setMinLimt}
                    />
                  ))
                )}
              </div>
              <div className={styles.selectDiskTip}>
                {currentProgress === 'selectDisk' && showMinLimtTip
                  ? intl.formatMessage(messages.selectDiskMinLmit)
                  : ''}
              </div>
            </Spin>
          </div>

          <ConfirmDiskFooter
            setUpdateDiskConfig={setUpdateDiskConfig}
            clickStartConfirmDisk={clickStartConfirmDisk}
            clickRefershEvent={clickRefershEvent}
            currentProgress={currentProgress}
            clickLastStepEvent={clickLastStepEvent}
            clickPartitionEvent={clickPartitionEvent}
            deletePartition={deletePartition}
            formatBlock={formatBlock}
            disabled={minLimt}
          />
        </div>
      )}

      <ChangeDisk
        // 分区之前允许缩小,除此之外都不允许缩小
        lessen={serverStatus === 'init' ? true : false}
        onOk={updateSize}
        type={serverStatus === 'init' ? 'danger' : 'primary'}
        okText={intl.formatMessage(serverStatus === 'init' ? messages.resetSize : messages.extension)}
      />
    </div>
  );
};

export default DiskConfig;
